<template>
    <div class="container mt-5">
      <h1 class="mb-4 text-primary"><i class="bi bi-person-badge"></i> More Student Details</h1>
      <p class="lead">Student ID: <span class="text-muted">{{ studentId }}</span></p>
      <p class="lead">Institute ID: <span class="text-muted">{{ instituteId }}</span></p>
      <button @click="goBack">Go Back</button>
  
      <div class="row">
        <div class="col-md-4 mb-4">
          <h2 class="h5 text-secondary"><i class="bi bi-plus-circle"></i> Add Student Item</h2>
          <StudentAddItem :studentId="studentId" :instituteId="instituteId" @student-item-added="fetchStudentItems"/>
        </div>
  
        <div class="col-md-4 mb-4">
          <h2 class="h5 text-secondary"><i class="bi bi-list-ul"></i> Show Student Items</h2>
          <ShowStudentItem ref="showStudentItem" :studentId="studentId" />
        </div>
  
        <div class="col-md-4 mb-4">
          <h2 class="h5 text-secondary"><i class="bi bi-qr-code-scan"></i> Student QR Code</h2>
          <StudentQR :studentId="studentId"/>
        </div>
        
              <!-- Payment Section -->
      <div class="col-md-3 mb-4">
        <h2 class="h5 text-secondary"><i class="bi bi-currency-exchange"></i> Payment Section</h2>
        <StudentPayment :studentId="studentId" @payment-updated="fetchStudentItems" />
      </div>

      </div>
    </div>
  </template>
  
  
  <script>
  import StudentAddItem from '@/components/Student/StudentMoreDetails/StudentAddItem.vue';
  import ShowStudentItem from '@/components/Student/StudentMoreDetails/ShowStudentItem.vue';
  import StudentQR from '@/components/Student/StudentMoreDetails/StudentQR.vue';
  import StudentPayment from '@/components/Student/StudentMoreDetails/StudentPayment.vue';
  
  export default {
    name: 'MoreStudentDetails',
    
    props: {
      studentId: {
        type: Number,
        required: true,
      },
      instituteId: {
        type: Number,
        required: true,
      },
    },
  
    components: {
      StudentAddItem,
      ShowStudentItem,
      StudentQR,
      StudentPayment,
    },
  
    methods: {
      fetchStudentItems() {
        // Trigger the fetchStudentItems method in the ShowStudentItem component
        this.$refs.showStudentItem.fetchStudentItems();
      },
      goBack() {
      this.$router.push({ path: '/adminHome', query: { currentPage: 'students' } });
    },
      // Add a beforeRouteLeave guard
  beforeRouteLeave(to, from, next) {
    // You can use this to set a global state or perform some actions before leaving
    next(); // Proceed to leave the route
  },

    },
    
  };
  </script>
  
  <style lang="scss" scoped>
  /* Custom styles for better aesthetics if needed */
  .container {
    background-color: #f8f9fa; /* Light background for contrast */
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  </style>
  